let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("icq5C")).then(() => parcelRequire('9o7yY'));